import GatepassDetails from "@features/gatepass/components/NormalGatepass/GatepassDetails";
import GroupMembers from "@features/gatepass/components/NormalGatepass/GroupMembers";
import Locations from "@features/gatepass/components/NormalGatepass/Locations";
import VehicleDetails from "@features/gatepass/components/NormalGatepass/VehicleDetails";
import VisitorDetails from "@features/gatepass/components/NormalGatepass/VisitorDetails";

const NormalGatepass = () => {
  return (
    <div data-testid="normal-gatepass-form" className="flex flex-col gap-8">
      <VisitorDetails />
      <GatepassDetails />
      <VehicleDetails />
      <Locations />
      <GroupMembers />
    </div>
  );
};

export default NormalGatepass;
